import Call from '../Call';
import {objToQs} from '../Utils';

const TrackerAffids = {
    get(tracker) {
        return Call(`trackerAffids/${tracker}`);
    }
};

export default TrackerAffids;


// WEBPACK FOOTER //
// ./src/services/API/components/TrackerAffids.js